/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} About_Section6_P1Inputs */

const en_about_section6_p1 = /** @type {(inputs: About_Section6_P1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PureJSON is built and maintained by Choi JY, a developer who spends the working day reading API responses, wrangling config files, and debugging data pipelines. The tools here started as things I needed myself and could not find in a version that respected my data. Every feature reflects a real problem I ran into at work.`)
};

const ko_about_section6_p1 = /** @type {(inputs: About_Section6_P1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PureJSON은 개발자 Choi JY가 만들고 운영합니다. 업무 시간 대부분을 API 응답을 읽고, 설정 파일을 손보고, 데이터 파이프라인을 디버깅하며 보냅니다. 이곳의 도구들은 제가 직접 필요했지만 데이터를 존중하는 형태로는 찾을 수 없었던 것들에서 시작했습니다. 모든 기능은 실제 업무에서 부딪힌 문제에서 나왔습니다.`)
};

const ja_about_section6_p1 = /** @type {(inputs: About_Section6_P1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PureJSON は開発者 Choi JY が作り、運営しています。仕事の時間の多くを API レスポンスを読み、設定ファイルを直し、データパイプラインをデバッグすることに使っています。ここにあるツールは、自分に必要だったのに、データを尊重する形では見つからなかったものから始まりました。すべての機能は実際の業務でぶつかった問題から生まれています。`)
};

/**
* | output |
* | --- |
* | "PureJSON is built and maintained by Choi JY, a developer who spends the working day reading API responses, wrangling config files, and debugging data pipelin..." |
*
* @param {About_Section6_P1Inputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const about_section6_p1 = /** @type {((inputs?: About_Section6_P1Inputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<About_Section6_P1Inputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_about_section6_p1(inputs)
	if (locale === "ko") return ko_about_section6_p1(inputs)
	return ja_about_section6_p1(inputs)
});